import { z } from 'zod';

export const CustomerFeaturesSchema = z.object({ passengerTransport: z.boolean() });

export type CustomerFeatures = z.infer<typeof CustomerFeaturesSchema>;

const CustomerProfileFeaturesSchema = z.object({ features: CustomerFeaturesSchema.nullish() });

export function readCustomerFeatures(profile: unknown): CustomerFeatures {
  const parsed = CustomerProfileFeaturesSchema.safeParse(profile);
  if (!parsed.success || !parsed.data.features) return { passengerTransport: false };
  return { passengerTransport: parsed.data.features.passengerTransport };
}
